import { z } from "zod";

// API01: thành công `{ data, meta: { requestId } }`; danh sách thêm `meta.page`. Lỗi một dạng duy nhất.
export const PageMeta = z.object({ nextCursor: z.string().nullable(), hasMore: z.boolean() }).strict();
export type PageMeta = z.infer<typeof PageMeta>;

export const Meta = z.object({ requestId: z.string(), page: PageMeta.optional() }).strict();

export const ErrorBody = z
  .object({
    error: z
      .object({
        code: z.string(),
        message: z.string(),
        details: z.record(z.string(), z.unknown()).optional(),
        requestId: z.string(),
      })
      .strict(),
  })
  .strict();
export type ErrorBody = z.infer<typeof ErrorBody>;

export const success = <T extends z.ZodType>(data: T) => z.object({ data, meta: Meta }).strict();
export const list = <T extends z.ZodType>(item: T) => z.object({ data: z.array(item), meta: Meta.extend({ page: PageMeta }) }).strict();

export function ok<T>(data: T, requestId: string, page?: PageMeta) {
  return { data, meta: page ? { requestId, page } : { requestId } };
}

export function errorBody(code: string, message: string, requestId: string, details?: Record<string, unknown>): ErrorBody {
  return { error: details ? { code, message, details, requestId } : { code, message, requestId } };
}
